import * as React from 'react';
import AppColors from '../common/colors';
import { StyleSheet, Text, View } from 'react-native';
import localization from '../common/localization';
import * as Sentry from '@sentry/react-native';
import AppIcon, { AppIcons } from './app_icon';
import { TimerType, VoidCb } from '../types/others';
import { ResetError } from '../types/errors';

type Props = React.PropsWithChildren<{
  isTv?: boolean;
  reset?: VoidCb;
}>;

type State = {
  errorMsg: boolean;
  timer?: TimerType;
  isReset?: boolean;
};

export default class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      errorMsg: false,
    };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    if (__DEV__) {
      this.setState({ errorMsg: true });
      return;
    }

    const isReset = error instanceof ResetError;
    const timer = setTimeout(
      () => {
        this.props.reset?.();
        this.setState({ errorMsg: false });
      },
      isReset ? 100 : 3000,
    );

    this.setState({ errorMsg: true, timer, isReset });
    if (isReset) return;
    Sentry.captureException(error);
  }

  render() {
    if (this.state.errorMsg) {
      if (this.state.isReset) return <View style={styles.container} />;
      return (
        <View style={styles.container}>
          <AppIcon name={AppIcons.stop_circle} color='red' size={144} />
          <Text style={this.props.isTv ? styles.textTv : styles.textMobile}>
            {localization.error.appCriticalError}
          </Text>
        </View>
      );
    }

    return this.props.children;
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: AppColors.mainBlack,
    justifyContent: 'center',
    alignItems: 'center',
  },
  textTv: {
    fontSize: 32,
    color: 'white',
    textAlign: 'center',
  },
  textMobile: {
    fontSize: 18,
    color: 'white',
    textAlign: 'center',
  },
});
